export * from './communication.interface';
export * from './communication.service';
export * from './communication.mock';
export const COMMUNICATION_SERVICE = Symbol('CommunicationService');
